/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useCallback, useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"

import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { T集計データ } from "./TukekaeZissekiList"
import CONSTANT from "../../../constant"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { T付替実績 } from "../../../service/budget/tukekaeZissekiList/TTukekaeZissekiList"
import _ from "lodash"

type TGridData = {
  部所名: string
  金額: number
  稼働台数: number
}

/**
 * 付替実績内訳モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const TukekaeZissekiUtiwakeModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    集計データ: T集計データ | undefined
  }
> = (props) => {
  //#region [state]
  // 検索項目

  // combobox
  // 部所
  const [部所名, set部所名] = useState<string | null>()

  // Grid

  const [自部所受注他部所運行flexGrid, set自部所受注他部所運行FlexGrid] =
    useState<wjcGrid.FlexGrid>()
  const [他部所受注自部所運行flexGrid, set他部所受注自部所運行FlexGrid] =
    useState<wjcGrid.FlexGrid>()

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = useCallback(
    (
      data: Array<T付替実績>,
      自部所受注フラグ: boolean
    ): wjcCore.CollectionView<TGridData> => {
      const convertData: TGridData[] = []

      const 部所List: {
        部所ID: number | undefined | null
        部所名: string
      }[] = _.uniqBy(data, 自部所受注フラグ ? "運行部所ID" : "受注部所ID").map(
        (d) => ({
          部所ID: 自部所受注フラグ
            ? d.運行部所ID ?? null
            : d.受注部所ID ?? null,
          部所名: 自部所受注フラグ
            ? d.運行部所略称 ?? "未登録"
            : d.受注部所略称 ?? "未登録",
        })
      )

      for (let key in 部所List) {
        const 部所 = 部所List[key]

        const filterData = data.filter((d) =>
          自部所受注フラグ
            ? d.運行部所ID === 部所.部所ID
            : d.受注部所ID === 部所.部所ID
        )

        if (filterData.length <= 0) continue

        const gridData: TGridData = {
          部所名: 部所.部所名,
          金額: _.sum(filterData.map((d) => d.金額 ?? 0)),
          稼働台数: _.sum(filterData.map((d) => d.配車件数 ?? 0)),
        }
        convertData.push(gridData)
      }

      return new wjcCore.CollectionView(convertData, {})
    },
    []
  )

  const gridInitialized =
    (
      setGrid: React.Dispatch<
        React.SetStateAction<wjcGrid.FlexGrid | undefined>
      >
    ) =>
    (grid: wjcGrid.FlexGrid) => {
      // 集計行追加
      grid.columnFooters.rows.push(new wjcGrid.GroupRow())

      // 部所未登録の場合赤字に
      grid.formatItem.addHandler((g, e) => {
        if (e.panel === g.cells) {
          const col = g.getColumn(e.col)
          switch (col.binding as keyof TGridData) {
            case "部所名":
              const data = g.getCellData(e.row, e.col, false)
              wjcCore.toggleClass(e.cell, "text-danger", data === "未登録")
              break
            default:
              break
          }
        }
      })

      setGrid(grid)
    }

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (
      自部所受注他部所運行flexGrid == null ||
      他部所受注自部所運行flexGrid == null ||
      props.集計データ == null
    )
      return

    console.log(props.集計データ.自部所受注他部所運行List)
    if (props.isShow) {
      set部所名(props.集計データ.部所略称)

      自部所受注他部所運行flexGrid.itemsSource = createCollectionView(
        props.集計データ.自部所受注他部所運行List,
        true
      )
      他部所受注自部所運行flexGrid.itemsSource = createCollectionView(
        props.集計データ.他部所受注自部所運行List,
        false
      )
      自部所受注他部所運行flexGrid.refresh()
      他部所受注自部所運行flexGrid.refresh()
    } else {
      // 非表示時中身を空にして閉じる
      set部所名("")
      if (自部所受注他部所運行flexGrid != null) {
        自部所受注他部所運行flexGrid.itemsSource = createCollectionView(
          [],
          true
        )
        自部所受注他部所運行flexGrid.refresh()
      }
      if (他部所受注自部所運行flexGrid != null) {
        他部所受注自部所運行flexGrid.itemsSource = createCollectionView(
          [],
          false
        )
        他部所受注自部所運行flexGrid.refresh()
      }
    }
  }, [
    props.isShow,
    自部所受注他部所運行flexGrid,
    他部所受注自部所運行flexGrid,
    props.集計データ,
  ])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "付替実績内訳"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Container fluid className="max-h-52rem">
        <Row className="mb-1">
          <Col>
            <h3>{部所名}</h3>
          </Col>
        </Row>
        <Row style={{ maxHeight: "24rem" }}>
          <Col>
            <h4>
              <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
              　他部所へ運行依頼
            </h4>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.CellRange}
              initialized={gridInitialized(set自部所受注他部所運行FlexGrid)}
              style={{ maxHeight: "20rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={198}
                header="付替先部所（依頼先）"
                binding="部所名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="金額"
                binding="金額"
                aggregate={wjcCore.Aggregate.Sum}></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="稼働台数"
                binding="稼働台数"
                aggregate={wjcCore.Aggregate.Sum}></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </Col>
        </Row>
        <Row style={{ maxHeight: "24rem" }}>
          <Col>
            <h4>
              <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon>
              　他部所からの運行依頼
            </h4>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.CellRange}
              initialized={gridInitialized(set他部所受注自部所運行FlexGrid)}
              style={{ maxHeight: "20rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={198}
                header="受注部所（依頼元）"
                binding="部所名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="金額"
                binding="金額"
                aggregate={wjcCore.Aggregate.Sum}></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={110}
                header="稼働台数"
                binding="稼働台数"
                aggregate={wjcCore.Aggregate.Sum}></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}
export default TukekaeZissekiUtiwakeModal
